import { Avatar, Box, Button } from "@mui/material"
import { ChevronRight } from "@mui/icons-material"

import { pillButtonSx } from "../styles/sectionStyles"

const ShowMoreButton = ({ label, onClick, align = "center" }) => (
    <Box
        sx={{
            mt: align === "right" ? 2 : 3,
            textAlign: align,
            ".MuiButton-root": {
                ...pillButtonSx,
                px: align === "right" ? 0 : 2,
                ...(align === "right" && {
                    "&:hover": {
                        background: "transparent",
                    },
                }),
            },
            ".MuiAvatar-root": {
                width: 30,
                height: 30,
                background: "#000435",
                ml: 1,
            },
        }}
    >
        <Button onClick={onClick} disableRipple={align === "right"}>
            {label}
            <Avatar>
                <ChevronRight />
            </Avatar>
        </Button>
    </Box>
)

export default ShowMoreButton
